import React from "react";
import { IconProps } from "../index";
import { colors } from "src/assets";

const Index: React.FC<IconProps> = ({ color, size }) => {
  const localWidth = size * (18 / 18);
  const localHeight = size * (18 / 18);
  const localColor = color || colors.white;
  return (
    <svg width={localWidth} height={localHeight} viewBox="0 0 18 18">
      <path
        d="M689.468,114.72a9,9,0,1,1,9-9A9.01,9.01,0,0,1,689.468,114.72Zm0-16.574a7.574,7.574,0,1,0,7.574,7.574A7.583,7.583,0,0,0,689.468,98.146Z"
        transform="translate(-680.468 -96.72)"
        fill={localColor}
      />
      <rect
        width="2.542"
        height="2.542"
        rx="1.271"
        transform="translate(3.912 7.996)"
        fill={localColor}
      />
      <rect
        width="2.542"
        height="2.542"
        rx="1.271"
        transform="translate(7.628 7.996)"
        fill={localColor}
      />
      <rect
        width="2.542"
        height="2.542"
        rx="1.271"
        transform="translate(11.344 7.996)"
        fill={localColor}
      />
    </svg>
  );
};

export default Index;
